/* eslint-disable import/prefer-default-export */

import getKey from 'lodash/get';
import isFunction from 'lodash/isFunction';

import Admin from 'hive-admin';

Admin.addToLibrary(
  'condition.testFieldValue',
  (field, op, value, parentIndex) => {
    const check = (
        isFunction(op)
      ? null
      : Admin.createFromLibrary('condition.check', {
          path1: field,
          op,
          value2: value,
        })
    );
    return (props) => {
      let fieldValue;
      if (Number.isFinite(parentIndex)) {
        fieldValue = (
            props.forms && props.forms[parentIndex]
          ? props.forms[parentIndex].getFieldValue(field)
          : undefined
        );
        if (typeof fieldValue === 'undefined') {
          fieldValue = (
              props.datas && props.datas[parentIndex]
            ? getKey(props.datas[parentIndex], field, fieldValue)
            : fieldValue
          );
        }
      } else {
        fieldValue = props.form.getFieldValue(field);
        if (typeof fieldValue === 'undefined') {
          fieldValue = getKey(props.data, field, fieldValue);
        }
      }
      return check ? check({ [field]: fieldValue }) : op(fieldValue, props);
    };
  },
);

Admin.addToLibrary(
  'condition.testPageFieldValue',
  (field, op, value) => {
    const check = (
        isFunction(op)
      ? null
      : Admin.createFromLibrary('condition.check', {
          path1: field,
          op,
          value2: value,
        })
    );
    return (props) => {
      let fieldValue = props.pageform.getFieldValue(field);
      if (typeof fieldValue === 'undefined') {
        fieldValue = getKey(props.parentData || props.data, field, fieldValue);
      }
      return check ? check({ [field]: fieldValue }) : op(fieldValue, props);
    };
  },
);

Admin.addToLibrary(
  'redirect.always',
  (destination = '/') => (
      isFunction(destination)
    ? destination
    : () => destination
  ),
);
